<template>
  <section>
    <div v-if="experience && experience.experience_photos.length > 0">
      <photos-mobile :experience="experience" v-if="$mq.phone"/>
      <photos-desktop :numPhotos="5" :experience="experience" v-else/>
      <!-- Gallery -->
      <Tinybox v-model="galleryIndex" :images="photoUrls" loop no-thumbs />
    </div>
    <div v-else>
      <loader/>
    </div>
  </section>
</template>

<script>
  import PhotosMobile from './PhotosMobile'
  import PhotosDesktop from './PhotosDesktop'
  import Loader from '../../loader/Loader'
  import fileHelpers from '../../../helpers/fileHelpers'

  export default {
    props: {
      experience: Object
    },
    components: {
      PhotosMobile,
      PhotosDesktop,
      Loader
    },
    data () {
      return {
        show: false,
        showTopNav: false,
        galleryIndex: null,
        options: {continuous: false},
        photoUrls: []
      }
    },
    methods: {
      openGallery (index) {
        this.galleryIndex = index
      }
    },
    mounted () {
      if (this.experience && this.experience.experience_photos.length > 0) {
        for (const experiencePhoto of this.experience.experience_photos) {
          if (!fileHelpers.isVideo(experiencePhoto.image_xl)) {
            this.photoUrls.push(experiencePhoto.image_xl)
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/experience/components/ExperiencePhotos.vue